/**
 * TestcaseResults component is responsible for displaying the details of
 * test cases for a student's programming submission. It uses the access control
 * variables to determine whether the test cases should be shown to the student
 * */

import React from "react";
import Testcase from "../Testcase/Testcase";
import "./testcase_details_student.styles.scss";
import { Alert } from "react-bootstrap";
import log from "loglevel";

export default function TestcaseResults({
  access,
  testResults,
  testcasesExportHandler,
}) {

  log.debug("TestcaseResults.jsx props: ", testResults);

  const countPassedTestcases = () => {
    let count = 0;
    testResults?.forEach((testcase) => {
      if (testcase.passed) {
        count++;
      }
    });
    return count;
  }

  // False for hidden/evaluation runs, where students never see the detailed table below.
  const canShowTestcaseDetails =
    access?.enable_display_visible_testcases ||
    access?.enable_display_hidden_testcases;

  // Testcases that errored; the table carrying the per-testcase error button may be gated off.
  const failedWithErrors = testResults?.filter(
    (testcase) =>
      testcase.error_messages ||
      testcase.compiler_errors ||
      testcase.return_code ||
      testcase.verdict
  ) ?? [];

  const errorVerdict =
    failedWithErrors.find((testcase) => testcase.verdict)?.verdict ||
    "Runtime Error";

  const hasResults = testResults && testResults.length > 0;

  return (
    //show Testcase details component by following access control
    <div>
      {/* An error banner always shows, even when the details table is gated off. */}
      {hasResults && failedWithErrors.length > 0 && (
        <Alert variant="danger">
          <strong>{errorVerdict}</strong>
          {` — ${failedWithErrors.length} of ${testResults.length} test case(s) did not run to completion. `}
          {canShowTestcaseDetails
            ? "See the Errors column below for details."
            : "Your program produced an error while running on the evaluation test cases, so no marks were awarded for them."}
        </Alert>
      )}

      {/* Suppressed when the table is hidden and something errored: a bare pass count then misleads */}
      {hasResults && (canShowTestcaseDetails || failedWithErrors.length === 0) && (
        <Alert variant="info">
          {`You have passed ${countPassedTestcases()} out of ${testResults.length} test cases.`}
        </Alert>
      )}
      {canShowTestcaseDetails ? (
        <>
          {testResults?.length > 0 ? (
            <Testcase
              testResults={testResults}
              testcasesExportHandler={testcasesExportHandler}
            />
          ) : null}
        </>
      ) : null}
    </div>
  );
}
